<template>
  <div class="ui-loading-spinner" :class="{ 'fullscreen': fullscreen }">
    <div class="spinner-container">
      <div class="spinner" :class="sizeClass"></div>
      <p v-if="message" class="loading-message">{{ message }}</p>
    </div>
  </div>
</template>

<script setup>
/**
 * 재사용 가능한 로딩 스피너 컴포넌트
 *
 * Props:
 * - size: 스피너 크기 ('small', 'medium', 'large')
 * - message: 로딩 메시지
 * - fullscreen: 전체 화면 중앙 정렬 여부
 */

const props = defineProps({
  size: {
    type: String,
    default: 'medium',
    validator: (value) => ['small', 'medium', 'large'].includes(value)
  },
  message: {
    type: String,
    default: '데이터를 불러오는 중...'
  },
  fullscreen: {
    type: Boolean,
    default: false
  }
});

const sizeClass = computed(() => `spinner-${props.size}`);
</script>

<script>
export default {
  name: 'UiLoadingSpinner'
};
</script>

<style lang="scss" scoped>
.ui-loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;

  &.fullscreen {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    z-index: 9999;
  }
}

.spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.spinner {
  border-radius: 50%;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #3498db;
  animation: spin 1s linear infinite;

  &.spinner-small {
    width: 24px;
    height: 24px;
    border-width: 2px;
  }

  &.spinner-medium {
    width: 40px;
    height: 40px;
    border-width: 3px;
  }

  &.spinner-large {
    width: 60px;
    height: 60px;
    border-width: 4px;
  }
}

.loading-message {
  margin: 0;
  color: #666;
  font-size: 14px;
  text-align: center;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>